// extracted by mini-css-extract-plugin
export default {"section":"Flat_section__mp8tQ","header":"Flat_header__URGvL","spacer":"Flat_spacer__I3IfR","content":"Flat_content__MWvFc","mobileSectionHeader":"Flat_mobileSectionHeader__B-dYR"};